import Vue from "vue";

export default {
  recuperarPaises() {
    return Vue.axios.get("pais");
  },
};
